import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {ErrorHandler, Injectable} from '@angular/core';
import {Observable, RetryConfig, catchError, retry, throwError, timer} from 'rxjs';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  retryConfig: RetryConfig = {
    count: 2,
    delay: (error, retryCount) => {
      // retry only transient server/network failures
      if (error.status === 0 || error.status === 503) {
        return timer(1000);
      }
      return throwError(() => error);
    },
  };

  constructor(private errorHandler: ErrorHandler) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      retry(this.retryConfig),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 503 || error.status === 0) {
          this.errorHandler.handleError(error);
        }
        return throwError(() => error);
      }),
    );
  }
}
